var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './Text.module.css';
export var TagName;
(function (TagName) {
    TagName["P"] = "p";
    TagName["SPAN"] = "span";
    TagName["EM"] = "em";
    TagName["LI"] = "li";
    TagName["DT"] = "dt";
    TagName["DD"] = "dd";
})(TagName || (TagName = {}));
export var TextSize;
(function (TextSize) {
    TextSize["XXXS"] = "xxxs";
    TextSize["XXS"] = "xxs";
    TextSize["XS"] = "xs";
    TextSize["S"] = "s";
    TextSize["M"] = "m";
    TextSize["L"] = "l";
    TextSize["XL"] = "xl";
    TextSize["XXL"] = "xxl";
    TextSize["XXXL"] = "xxxl";
})(TextSize || (TextSize = {}));
const Text = (_a) => {
    var { children, className, tagName = TagName.SPAN, size, color, bold } = _a, other = __rest(_a, ["children", "className", "tagName", "size", "color", "bold"]);
    // TagName has to start with capital letter, otherwise react will complain
    const Tag = tagName;
    const classNames = cx(styles.preWrap, className, styles[`size-${size}`], {
        [styles[`color-${color}`]]: !!color,
        [styles.bold]: bold
    });
    if (children instanceof Function) {
        return children(Object.assign({ className: classNames }, other));
    }
    return (React.createElement(Tag, Object.assign({ className: classNames }, other), children));
};
export default Text;
//# sourceMappingURL=Text.js.map